export default __webpack_public_path__ + "static/product_item_006-fadcdaa7d297692f71eec4eb664e17e4.jpg";